import React from 'react';

const contentContainerStyle = {
	flexGrow: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'start',
	justifyContent: 'center',
	width: '100%',
	maxWidth: 650,
};

const ContentContainer = ({ children, style, innerStyle = {}, id, ...props }) => {
	return (
		<div id={id} style={{ ...contentContainerStyle, ...style }} {...props}>
			<div style={{
				padding: '1rem',
				width: '100%',
				boxSizing: 'border-box',
				marginBottom: 100,
				display: 'flex',
				flexDirection: 'column',
				gap: 16,
				...innerStyle,
			}}>
				{children}
			</div>
		</div>
	);
};

export default ContentContainer;